import React from "react";
import { Link } from "gatsby";
import ArrowIcon from "../svg-components/ArrowIcon";
import AcceptIcon from "../svg-components/AcceptIcon";
import DeclineIcon from "../svg-components/DeclineIcon";

const Button = ({ isActive, to, title, target, type, children, inverted = false, isButton = false, onClick }) => {
  
  let linkClass = "";

  if ((target === null) || (target === '')) {
    target = '_self';
  }

  switch (type) {
    case 'default':
      linkClass = 'btn';
      break;
    case 'sales-and-marketing':
    case 'senior-leadership':
    case 'flaunt':
      linkClass = 'btn btn-flaunt';
      break;
    case 'alt':
      linkClass = 'btn btn-alt';
      break;
    case 'seo':
      linkClass = 'btn btn-seo';
      break;      
    case 'paid-media':
      linkClass = 'btn btn-paid-media';
      break;
    case 'creative':
    case 'creative-marketing':
      linkClass = 'btn btn-creative';
      break;
    case 'content':
    case 'content-marketing':
      linkClass = 'btn btn-content-marketing';
      break;
    case 'development':
      linkClass = 'btn btn-development';
      break;
    case 'pr':
      linkClass = 'btn btn-pr';
      break;
    case 'company-updates':
      linkClass = 'btn btn-company-updates';
      break;
    case 'resting-pitch-face':
      linkClass = 'btn btn-resting-pitch-face';
      break;
    case 'white':
      linkClass = 'btn btn-white';
      break;
    case 'see-more':
      linkClass = 'btn btn-see-more';
      break;
    case 'see-less':
      linkClass = 'btn btn-see-less';
      break;
    case 'see-more-podcast':
      linkClass = 'btn btn-see-more-podcast';
      break;
    case 'see-less-podcast':
      linkClass = 'btn btn-see-less-podcast';
      break;
    case '404':
      linkClass = 'btn btn-404';
      break;
    case 'nav-contact':
      linkClass = 'btn btn-nav-contact';
      break;
    case 'nav-podcast':
      linkClass = 'btn btn-nav-contact podcast';
      break;
    case 'accept':
      linkClass = 'btn btn-accept';
      break;
    case 'decline':
      linkClass = 'btn btn-decline';
      break;
    case 'slide-out':
      linkClass = 'btn btn-white slide_out_btn';
      break;
    default:
      linkClass = 'btn';
      break;
  }

  if(inverted) {
    linkClass += "-inverted";
  }

  if (isActive) {
    linkClass += " btn-selected";
  }

  if (isButton) {
    return (
      <button
        onClick={onClick}
        title={title}
        className={linkClass}
      >
        {children}
        <div className="btn-arrow-container">
          {type !== 'accept' && type !== 'decline' && <ArrowIcon className="btn-arrow"/>}
          {type === 'accept' && <AcceptIcon className="btn-accept"/>}
          {type === 'decline' && <DeclineIcon className="btn-decline"/>}
        </div>
      </button>
    );
  }

  if (target === '_blank') {
    return (
      <a
        href={to}
        title={title}
        className={linkClass}
        target={target}
        rel="noopener noreferrer"
      >
        {children}
        <div className="btn-arrow-container">
          <ArrowIcon className="btn-arrow"/>
        </div>     
      </a>
    );
  }

  return (
    <Link 
      to={to}
      title={title}
      className={linkClass}
      target={target}
    >
      {children}
      <div className="btn-arrow-container">
        <ArrowIcon className="btn-arrow"/>
      </div> 
    </Link>
  );
}

export default Button;
